import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
@Injectable()

export class ResidentsService {
    constructor(private http: HttpClient) { }


    //owner

    getpatients(): Observable<any> {

        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/owner/patient/list`).pipe(map(user => user));
    }



    addprogressnote(patient_id: any, date: any, time: any, customnote: any, note: any) {
        let formData = {
            'patient_id': patient_id,
            'date': date,
            'time': time,
            'custome_note': JSON.stringify(customnote),
            'note': note
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/owner/progress/add/` + patient_id, formData)
            .pipe(map(user => {
                return user;
            }));
    }


    





    //staff
    getstaffpatients(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/patient/all-list`).pipe(map(user => user));
    }

    getstaffpatientsbyfacility(facility_id: any, search: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/patient/list?facility_id=` + facility_id + '&search=' + search).pipe(map(user => user));
    }

    getstafffacilities(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/patient/dropdown`)
        .pipe(map(user => {
            // localStorage.setItem(`${environment.appName}` + 'facility_id', user.data[0]._id);
            // localStorage.setItem(`${environment.appName}` + 'facility_name', user.data[0].fecility_name);
            return user;
        }));
       
        // return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/patient/dropdown`).pipe(map(user => user));
    }

    getstaffbulletinboard(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/bulletin-board/list`).pipe(map(user => user));
    }

    getstaffaccompained(facility_id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/doctor-note/dropdown?_id=` + facility_id).pipe(map(user => user));
    }
    getstaffphysician(facility_id: any,search:any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/directory/physician?search=` + search).pipe(map(user => user));
    }

    addstaffprogressnote(patient_id: any, date: any, time: any, customnote: any, note: any) {
        let formData = {
            'patient_id': patient_id,
            'date': date,
            'time': time,
            'custome_note': JSON.stringify(customnote),
            'note': note
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/progress/add/` + patient_id, formData)
            .pipe(map(user => {
                return user;
            }));
    }

    groupstaffprogressnote(patient: any, date: any, time: any, customnote: any, note: any) {
        let formData = {
            'patient_id': JSON.stringify(patient),
            'date': date,
            'time': time,
            'custome_note': JSON.stringify(customnote),
            'note': note
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/group-action/progess-note` , formData)
            .pipe(map(user => {
                return user;
            }));
    }

    updatestaffprogressnote(id: any, date: any, time: any, customnote: any, note: any) {
        let formData = {
            'date': date,
            'time': time,
            'custome_note': JSON.stringify(customnote),
            'note': note
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/progress/update/` + id, formData)
            .pipe(map(user => {
                return user;
            }));
    }

    addstaffbulletinnote(date: any, note: any) {
        let formData = {
            'date': date,
            'note': note
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/bulletin-board/add/`, formData)
            .pipe(map(user => {
                return user;
            }));
    }

    updatestaffbulletinnote(id: any, date: any, note: any) {
        let formData = {
            'date': date,
            'note': note
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/bulletin-board/update/` + id, formData)
            .pipe(map(user => {
                return user;
            }));
    }

    deletestaffbulletinnote(id: any) {
        // let formData={
        //     'date':date,
        //     'note':note
        // }
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/bulletin-board/delete/` + id)
            .pipe(map(user => {
                return user;
            }));
    }


    addstaffdoctornote(patientid: any, date: any, time: any,
        physician: any, accompany: any, notes: any, appointment: any, appointment_date: any,
        appointment_start_time: any, appointment_end_time: any,next_physician: any, next_accompany: any, reason: any,eventtype:any) {
        let formData = {
            'patient_id': patientid,
            'appointment_date': date,
            'appointment_time': time,
            'accompanied_by': accompany,
            'physician': physician,
            'note': notes,
            'next_appointment': appointment,
            'next_appointment_date': appointment_date,
            'next_appointment_startTime': appointment_start_time,
            'next_appointment_endTime': appointment_end_time,
            'next_accompanied_by': next_accompany,
            'next_physician': next_physician,
            'next_note': reason,
            'next_event_type':eventtype
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/doctor-note/add/` + patientid, formData)
            .pipe(map(user => {
                return user;
            }));
    }


    groupstaffdoctornote(patient: any, date: any, time: any,
        physician: any, accompany: any, notes: any, appointment: any, appointment_date: any,
        appointment_start_time: any, appointment_end_time: any,next_physician: any, next_accompany: any, reason: any,eventtype:any) {
        let formData = {
            'patient_id': JSON.stringify(patient),
            'appointment_date': date,
            'appointment_time': time,
            'accompanied_by': accompany,
            'physician': physician,
            'note': notes,
            'next_appointment': appointment,
            'next_appointment_date': appointment_date,
            'next_appointment_startTime': appointment_start_time,
            'next_appointment_endTime': appointment_end_time,
            'next_accompanied_by': next_accompany,
            'next_physician': next_physician,
            'next_note': reason,
            'next_event_type':eventtype
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/group-action/doctor-note`, formData)
            .pipe(map(user => {
                return user;
            }));
    }


    updatestaffdoctornote(noteid: any, date: any, time: any,
        physician: any, accompany: any, notes: any, appointment: any, appointment_date: any,
        appointment_start_time: any,appointment_end_time: any, next_physician: any, next_accompany: any, reason: any,eventtype:any) {
        let formData = {
            'appointment_date': date,
            'appointment_time': time,
            'accompanied_by': accompany,
            'physician': physician,
            'note': notes,
            'next_appointment': appointment,
            'next_appointment_date': appointment_date,
            'next_appointment_startTime': appointment_start_time,
            'next_appointment_endTime': appointment_end_time,
            'next_physician': next_physician,
            'next_note': reason,
            // 'next_event_type':eventtype
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/doctor-note/update/` + noteid, formData)
            .pipe(map(user => {
                return user;
            }));
    }




    getstaffprogressnote(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/progress/list/` + id).pipe(map(user => user));
    }

    getstaffdoctorsnote(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/doctor-note/list/` + id).pipe(map(user => user));
    }
    getstaffactivemedication(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/medication/active-list/` + id).pipe(map(user => user));
    }
    getstaffinactivemedication(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/medication/discontinued/` + id).pipe(map(user => user));
    }

    getpatientbyId(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/patient/patient-data/` + id).pipe(map(user => user));
    }


    deletestaffprogressnote(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/progress/delete/` + id)
            .pipe(map(user => {
                return user;
            }));
    }

    deletestaffdoctornote(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/doctor-note/delete/` + id)
            .pipe(map(user => {
                return user;
            }));
    }

    getdoctornotebyid(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/doctor-note/singlelist/` + id).pipe(map(user => {
            return user
        }));
    }



    addstaffmedication(patientId:any,medication_name:any,prn:any,
        priscription_number:any,strength:any,quantity:any,instruction:any,treatment:any,
        physician:any,pharmacy:any,date_filled:any,expiration_date:any,start_date:any,
       end_date:any,refills:any,sideeffects:any) {
        let formData = {
            'patient_id': patientId,
            'medication_name': medication_name,
            'prn_status': prn,
            'prescription_number': priscription_number,
            'strength': strength,
            'quantity': quantity,
            'instructions': instruction,
            'treatment': treatment,
            'physician': physician,
            'pharmacy': pharmacy,
            'date_filled': date_filled,
            'expiration_date': expiration_date,
            'start_date':start_date,
            'end_date':end_date,
            'refills':refills,
            'side_efects':sideeffects,
            'continue_status':1
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/medication/add/` + patientId, formData)
            .pipe(map(user => {
                return user;
            }));
    }


    updatestaffmedication(noteid:any,medication_name:any,prn:any,
        priscription_number:any,strength:any,quantity:any,instruction:any,treatment:any,
        physician:any,pharmacy:any,date_filled:any,expiration_date:any,start_date:any,
       end_date:any,refills:any,sideeffects:any,continue_status:any,continue_date:any,continue_time:any,reason:any) {
        let formData = {
            // 'patient_id': noteid,
            'medication_name': medication_name,
            'prn_status': prn,
            'prescription_number': priscription_number,
            'strength': strength,
            'quantity': quantity,
            'instructions': instruction,
            'treatment': treatment,
            'physician': "64058920138a1404599bfc6d",
            'pharmacy': pharmacy,
            'date_filled': date_filled,
            'expiration_date': expiration_date,
            'start_date':start_date,
            'end_date':end_date,
            'refills':refills,
            'side_efects':sideeffects,
            'continue_status':continue_status,
            'discontinue_date':continue_date,
            'discontinue_time':continue_time,
            'reason':reason
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/medication/update/` + noteid, formData)
            .pipe(map(user => {
                return user;
            }));
    }


    getmediactionbyid(id: any): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/medication/medicine-detail/` + id).pipe(map(user => {
            return user
        }));
    }


    deletemedication(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/medication/delete/` + id)
            .pipe(map(user => {
                return user;
            }));
    }



    addstaffcalender(patientid: any, eventtype:any,date: any, time:any,
        physician: any, accompany: any, reason: any) {
        let formData = {
            'patient_id': patientid,
            'appointment_date': date,
            'appointment_time': JSON.stringify(time),
            'event_type': eventtype,
            'physician': physician,
            'reason': reason,
            
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/calender-event/add/` + patientid, formData)
            .pipe(map(user => {
                return user;
            }));
    }


    groupstaffcalender(patient: any, eventtype:any,date: any, time:any,
        physician: any, accompany: any, reason: any) {
        let formData = {
            'patient_id': JSON.stringify(patient),
            'appointment_date': date,
            'appointment_time': JSON.stringify(time),
            'event_type': eventtype,
            'physician': physician,
            'reason': reason,
            
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/group-action/calender-event` , formData)
            .pipe(map(user => {
                return user;
            }));
    }



}
